//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AQCard from "@/components/Generics/AQCard/AQCard.vue";
import { mapActions } from "vuex";
import { APP_PERMS_VIEW_INTERFACES, PERMISSIONS_CODES, PERMISSIONS_ROLES } from "./appPermissionsRolesConst";

export default {
    name: "AppPermissionsViewDetails",
    components: { AQCard },
    props: {
        currentRole: {
            type: Object,
            default: () => ({})
        },
        dynamicPermissions: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            defaultPermsInterfaces: APP_PERMS_VIEW_INTERFACES,
            defaultPermissionsCodes: PERMISSIONS_CODES,
            defaultPermissionsRoles: PERMISSIONS_ROLES,
            dataPermissions: {}
        };
    },
    computed: {
        getTitleContainer() {
            const { code, name } = this.currentRole || {};
            return this.defaultPermissionsRoles.includes(code) ? this.$t(`applicationPermissions.${code}Role`) : name;
        }
    },
    created() {
        this.defaultPermsInterfaces = [...this.defaultPermsInterfaces, ...this.dynamicPermissions];
        this.getPermissionsRole();
    },
    methods: {
        ...mapActions("apps", ["actGetPermissionsForRole"]),
        getPermissionsRole() {
            const { code } = this.currentRole || {};
            if (code) {
                this.actGetPermissionsForRole(code).then(
                    data => {
                        if (data && data.data) {
                            const { permission } = data.data;
                            this.dataPermissions = permission || {};
                        }
                    }
                );
            }
        },
        setPermissions(data, type) {
            let response = false;
            const { g: owner } = this.dataPermissions;
            const isDynamicPermission = !this.defaultPermissionsCodes.includes(data.code);
            if (owner === "o") {
                if (isDynamicPermission) {
                    response = type !== "w";
                } else {
                    response = true;
                }
            } else if (isDynamicPermission) {
                const { DP: { [data.code]: permission } = {} } = this.dataPermissions;
                if (permission) {
                    const { PP: { g: permissionRight } = {} } = permission;
                    response = permissionRight === type;
                }
            } else {
                const pCode = data.parentCode;
                const { g: globalPermission } = this.dataPermissions[pCode] || {};
                if (pCode && pCode === "AS" && globalPermission) {
                    response = globalPermission === "w" || (globalPermission === "r" && type === "r");
                } else if (data) {
                    const permissions = this.dataPermissions[pCode];
                    const { g: gChildPermission } = permissions && permissions[data.code] ? permissions[data.code] : {};
                    const { g: gParentPermission } = this.dataPermissions[data.code] || {};
                    if ((pCode && gChildPermission && (gChildPermission === "w" || gChildPermission === type))
                        || (gParentPermission && (gParentPermission === "w" || gParentPermission === type))) {
                        response = true;
                    }
                }
            }

            return response;
        }
    }
};
